import React, { useState, useEffect } from "react"
import { Row, Col, Card, CardBody, Input, Button, Table } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import { Link, useHistory } from "react-router-dom"
import ReactPaginate from "react-paginate"
import { URLS } from "../../Url"
import axios from "axios"

function SellersList() {
  ///////////////////////////Get_authUser///////////////////////////////////////////
  var GetAuth = localStorage.getItem("authUser")
  var TokenJson = JSON.parse(GetAuth)
  var TokenData = TokenJson.token

  ///////////////////////////Get_data/////////////////////////////////////////////
  const [Seller, setSeller] = useState([])

  useEffect(() => {
    GetSellers()
    Pop_up()
  }, [])

  const GetSellers = () => {
    var token = TokenData
    axios
      .post(
        URLS.GetSeller,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setSeller(res.data.data)
      })
  }

  ///////////////////////////Search_data//////////////////////////////////////////
  const [Searchs, setSearchs] = useState([])

  const Search = e => {
    let myUser = { ...Searchs }
    myUser[e.target.name] = e.target.value
    setSearchs(myUser)
    var token = TokenData

    axios
      .post(
        URLS.GetSellerSearch + `${e.target.value}`,
        {},

        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setSeller(res.data.data)
      })
  }

  ///////////////////////////listPerPage////////////////////////////////////////////

  const [listPerPage] = useState(5)
  const [pageNumber, setPageNumber] = useState(0)

  const pagesVisited = pageNumber * listPerPage
  const lists = Seller.slice(pagesVisited, pagesVisited + listPerPage)
  const pageCount = Math.ceil(Seller.length / listPerPage)
  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }

  //////////////////////////Updata_Form_data////////////////////////////////////
  const history = useHistory()

  const EdiSeller = data => {
    sessionStorage.setItem("Sellerid", data._id)
    history.push("/EditSeller")
  }

  const ViewSeller = data => {
    sessionStorage.setItem("Sellerid", data._id)
    history.push("/ViewSeller")
  }

  const Pop_up = () => {
    const location = sessionStorage.getItem("tost")
    if (location != "") {
      toast(location)
      sessionStorage.clear()
    } else {
      sessionStorage.clear()
    }
  }

  ///////////////////////////Delete_data/////////////////////////////////////////
  const DeleteData = data => {
    const confirmBox = window.confirm("Do you really want to Delete?")
    if (confirmBox === true) {
      DeleteSellerData(data)
    }
  }
  const DeleteSellerData = data => {
    var token = TokenData
    var remid = data._id
    axios
      .delete(URLS.DeleteSeller + remid, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(
        res => {
          if (res.status === 200) {
            toast(res.data.message)
            GetSellers()
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Bizzmate Supplier" breadcrumbItem="Store List" />
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <Row>
                    <Col>
                      <Link to="/addSeller">
                        <Button color="primary" className="text-white">
                          Add Store <i className="bx bx-plus-circle"></i>
                        </Button>
                      </Link>
                    </Col>
                    <Col>
                      <div style={{ float: "right" }}>
                        <Input
                          type="search"
                          name="search"
                          value={Searchs.search}
                          onChange={Search}
                          className="form-control"
                          placeholder="Search.."
                          autoComplete="off"
                        />
                      </div>
                    </Col>
                  </Row>
                  <div className="table-rep-plugin mt-4 table-responsive">
                    <Table hover className="table table-bordered mb-4 ">
                      <thead>
                        <tr className="text-center">
                          <th>SlNo</th>
                          <th>Seller Name</th>
                          <th>Email </th>
                          <th>Image</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lists.map((data, key) => (
                          <tr key={key} className="text-center">
                            <td>{(pageNumber - 1) * 5 + key + 6}</td>
                            <td>{data.sellerFullName}</td>
                            <td>{data.sellerEmail}</td>
                            <td>
                              <img
                                src={URLS.Base + data.storeLogo}
                                style={{ width: "100px" }}
                              />
                            </td>
                            <td>
                              {data.storestatus == "active" ? (
                                <>
                                  <span className="badge bg-success">
                                    {data.storestatus}
                                  </span>
                                </>
                              ) : (
                                <>
                                  <span className="badge bg-danger">
                                    {data.storestatus}
                                  </span>
                                </>
                              )}
                            </td>
                            <td>
                              <Button
                                onClick={() => {
                                  EdiSeller(data)
                                }}
                                size="sm"
                                className="m-1"
                                color="primary" 
                              >
                                <div className="d-flex">
                                  <i className="bx bx-edit"></i>
                                </div>
                              </Button>
                              <Button
                                onClick={() => {
                                  ViewSeller(data)
                                }}
                                style={{
                                  padding: "6px",
                                  margin: "3px",
                                }}
                                size="sm"
                                className="m-1"
                                color="primary"
                              >
                                <i className="mdi mdi-eye-circle-outline text-primary"></i>
                              </Button>
                              <Button
                                size="sm"
                                className="m-1"
                                color="danger"
                                onClick={() => {
                                  DeleteData(data)
                                }}
                              >
                                <div className="d-flex">
                                  <i className="bx bx-trash"></i>
                                </div>
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <div
                      className="d-flex mt-3 mb-1"
                      style={{ float: "right" }}
                    >
                      <ReactPaginate
                        previousLabel={"Previous"}
                        nextLabel={"Next"}
                        pageCount={pageCount}
                        onPageChange={changePage}
                        containerClassName={"pagination"}
                        previousLinkClassName={"previousBttn"}
                        nextLinkClassName={"nextBttn"}
                        disabledClassName={"disabled"}
                        activeClassName={"active"}
                        total={lists.length}
                      />
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ToastContainer />
        </div>
      </div>
    </React.Fragment>
  )
}

export default SellersList
